import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  ADD_SURVEY_WELCOME,
  EDIT_SURVEY_WELCOME,
  LIST_SURVEY_WELCOME,
  VIEW_SURVEY_WELCOME,
  DELETE_SURVEY_WELCOME,

} from "./actionTypes"
import { surveyWelcomeSuccess, surveyWelcomeError } from "./actions"


import {
  onAddSurveyWelcome,
  onEditSurveyWelcome,
  onListSurveyWelcome,
  onViewSurveyWelcome,
  onSortSurveyWelcome,
  onDeleteSurveyWelcome,

} from "helpers/backend_api_helper";

// add Survey Welcome
function* addSurveyWelcome({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSurveyWelcome, data);
    yield put(surveyWelcomeSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(surveyWelcomeError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Survey Welcome
function* editSurveyWelcome({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSurveyWelcome, data, id);
    yield put(surveyWelcomeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyWelcomeError(error?.response?.data?.message || "Server Error"));
  }
}

// list Survey Welcome
function* listSurveyWelcome({ payload: { data, callback } }) {
  try {
    const response = yield call(onListSurveyWelcome, data);
    yield put(surveyWelcomeSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyWelcomeError(error?.response?.data?.message || "Server Error"));
  }
}

// view Survey Welcome
function* viewSurveyWelcome({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSurveyWelcome, data);
    yield put(surveyWelcomeSuccess(response));

  } catch (error) {
    yield put(surveyWelcomeError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Survey Welcome
function* deleteSurveyWelcome({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSurveyWelcome, data);
    yield put(surveyWelcomeSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(surveyWelcomeError(error?.response?.data?.message || "Server Error"));
  }
}



function* configSurveyWelcomeSaga() {
  yield takeEvery(ADD_SURVEY_WELCOME, addSurveyWelcome);
  yield takeEvery(EDIT_SURVEY_WELCOME, editSurveyWelcome);
  yield takeEvery(LIST_SURVEY_WELCOME, listSurveyWelcome);
  yield takeEvery(VIEW_SURVEY_WELCOME, viewSurveyWelcome);
  yield takeEvery(DELETE_SURVEY_WELCOME, deleteSurveyWelcome);
}

export default configSurveyWelcomeSaga;

